import type {
  CoasterProject,
  TrackPieceDefinitionId,
  TrackPieceParameters,
} from '../schema/index.ts';
import { newStableId } from './operations.ts';

export function reconcilePieceGroups(project: CoasterProject): CoasterProject {
  const next = structuredClone(project);
  const validSections = new Set(next.track.sections.map((section) => section.id));
  const claimed = new Set<string>();
  next.editor.pieceGroups = next.editor.pieceGroups
    .map((piece) => ({
      ...piece,
      sectionIds: piece.sectionIds.filter((id) => {
        if (!validSections.has(id) || claimed.has(id)) return false;
        claimed.add(id);
        return true;
      }),
    }))
    .filter((piece) => piece.sectionIds.length > 0);
  for (const section of next.track.sections) {
    if (claimed.has(section.id)) continue;
    next.editor.pieceGroups.push({
      id: newStableId('piece'),
      definitionId: 'custom',
      sectionIds: [section.id],
      parameters: null,
    });
  }
  return next;
}

export function assignPieceGroup(
  project: CoasterProject,
  sectionIds: readonly string[],
  definitionId: TrackPieceDefinitionId,
  parameters: TrackPieceParameters | null = null,
): CoasterProject {
  const next = reconcilePieceGroups(project);
  const assigned = new Set(sectionIds);
  next.editor.pieceGroups = next.editor.pieceGroups
    .map((piece) => ({ ...piece, sectionIds: piece.sectionIds.filter((id) => !assigned.has(id)) }))
    .filter((piece) => piece.sectionIds.length > 0);
  if (sectionIds.length)
    next.editor.pieceGroups.push({
      id: newStableId('piece'),
      definitionId,
      sectionIds: [...sectionIds],
      parameters,
    });
  return reconcilePieceGroups(next);
}

export function markSectionsCustom(
  project: CoasterProject,
  sectionIds: readonly string[],
): CoasterProject {
  const next = reconcilePieceGroups(project);
  const affected = new Set(sectionIds);
  for (const piece of next.editor.pieceGroups) {
    if (piece.sectionIds.some((id) => affected.has(id))) {
      piece.definitionId = 'custom';
      piece.parameters = null;
    }
  }
  return next;
}
